import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';

@Injectable()
export class YaBoService {

    constructor(
        private httpService: HttpService,
        private AppConfig: AppConfig) { }

    /**登录亚博棋牌 */
    loginYaBo() {
        let url = AppConfig.GetProdUrl() + "/YaBo/LoginYaBo";
        return this.httpService.post(url, '');
    }
    /**转账到亚博 */
    transferToYaBo(amount: number) {
        let url = AppConfig.GetProdUrl() + "/YaBo/TransferToYaBo";
        return this.httpService.post(url, { Amount: amount, Type: 'yb1' });
    }
    /**亚博棋牌转出 */
    transferFromYaBo(amount: number) {
        let url = AppConfig.GetProdUrl() + "/YaBo/TransferFromYaBo";
        return this.httpService.post(url, { Amount: amount, Type: 'yb2' });
    }
    /**获取亚博棋牌余额 */
    getYaBoBalance() {
        let url = AppConfig.GetProdUrl() + "/YaBo/GetBalance";
        return this.httpService.post(url, '');
    }
    /**获取转账记录 */
    getTransferList(params) {
        let url = AppConfig.GetProdUrl() + "/YaBo/GetTransferList";
        return this.httpService.post(url, params);
    }
    /**获取投注记录 */
    getBettingList(params) {
        let url = AppConfig.GetProdUrl() + "/YaBo/GetBettingList";
        return this.httpService.post(url, params);
    }
    /**获取游戏列表下拉菜单 */
    getGameListDrop(params) {
        let url = AppConfig.GetProdUrl() + "/YaBo/GetGameListDrop";
        return this.httpService.post(url, params);
    }

    /**
     * 登录ob体育
     */
    loginOb() {
        let url = AppConfig.GetProdUrl() + "/Ob/LoginOb";
        return this.httpService.post(url, { Device: 2});
    }
    /**转账到Ob体育 */
    transferToOb(amount: number) {
        let url = AppConfig.GetProdUrl() + "/Ob/TransferToOb";
        return this.httpService.post(url, { Amount: amount, Type: '0' });
    }
    /**获取OB体育余额 */
    getObBalance() {
        let url = AppConfig.GetProdUrl() + "/Ob/GetBalance";
        return this.httpService.post(url, '');
    }
    /**OB体育转出 */
    transferFromOb(amount: number) {
        let url = AppConfig.GetProdUrl() + "/Ob/TransferFromOb";
        return this.httpService.post(url, { Amount: amount, Type: '1' });
    }
    /**获取OB体育转账记录 */
    getObTransferList(params) {
        let url = AppConfig.GetProdUrl() + "/Ob/GetTransferList";
        return this.httpService.post(url, params);
    }
    /**获取OB体育投注记录 */
    getObBettingList(params) {
        let url = AppConfig.GetProdUrl() + "/Ob/GetBettingList";
        return this.httpService.post(url, params);
    }
}


// WEBPACK FOOTER //
// ./src/services/yabo.service.ts